<template>
  <v-container>
    <v-layout row wrap  align-top class="text-xs-center">
        <v-flex xs12 class="pa-2">

          <h2 class="display-1" style="text-decoration: underline;">Pay for Classes</h2>
        </v-flex>
        <v-flex xs12>
              <p>10 week session: $325</p>
              <p>10 week adaptive session: $260</p>
              <p>Boards are available to break after class. The cost is $4 or you can purchase 5 for $20.</p>
              <p>
                $350 for one week session of Kick It Up Camp. $100 deposit required at time of registration.
              </p>
              <!-- <v-flex xs12>
                <h3>Tournament pricing are as follows:</h3>
                <h4>1 event  $20</h4>
                <h4>2 events $35</h4>
                <h4>3 events $50</h4>
                <h4>4 events $60</h4>
                <h3>Payment due at time of registration. Registration due by 11/25.</h3>
              </v-flex> -->
        </v-flex>
        <!-- <v-flex xs12>
              <p>10 week session, 1 day a week: $300</p>
              <p>10 week session, 2 day a week: $600</p>
              <p>Boards are available to break after class. The cost is $4 or you can purchase 5 for $20.</p>
        </v-flex> -->
        <v-flex xs12 sm6 pa-4 class="text-xs-center">
          <h3>Venmo: Lisa-Hanson-3</h3>
          <v-btn color="primary" href="https://venmo.com/lisa-hanson-3">Link to Venmo</v-btn>
        </v-flex>
        <v-flex xs12 sm6 pa-4 class="text-xs-center">
          <h3>Paypal</h3>
          <v-btn color="primary" href="https://paypal.me/lisahanson301?locale.x=en_US">Link to Paypal</v-btn>
        </v-flex>


        <!-- <v-flex xs12 sm6 pa-4 >
          <h3>Paypal</h3>
          <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_s-xclick">
            <table>
            <tr>
              <td>
                <input type="hidden" name="on0" value="TKD class">
              </td>
            </tr>
            <tr>
              <td style="text-align:center;">
                <select name="os0">
                    <option value="Option 1">1 Class $12.00 USD</option>
                    <option value="Option 2">2 Classes $24.00 USD</option>
                    <option value="Option 3">4 Classes $48.00 USD</option>
                </select>
              </td>
            </tr>
            </table>
            <input type="hidden" name="encrypted" value="-----BEGIN PKCS7-----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-----END PKCS7-----">
            <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
            </form>
        </v-flex> -->
        <v-flex class="text-center">
          <b>Viking Martial Arts Refund Policy:</b>
            The total session tuition must be paid in full at the time of registration. No student will be added to the class list without full payment.

If a student misses a class, they may make it up during the scheduled make-up classes at the end of the session or join another class with Miss Lisa’s consent. Please note that there are no refunds or credits provided for any reason, and there are no exceptions to this policy.

          
          <v-flex xs12>
            <b>Kick It Up Summer Camp Refund Policy:</b> There is a $100 non-refundable deposit required at the time of registration. A camper will not be added to the camp roster without a deposit. The remaining balance has to be paid in full by June 1st.  There are no refunds or credits for any reason after June 1st. There are no exceptions to this policy.


          </v-flex>
        </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    computed: {
      size () {
        const binding = {}
        if (this.$vuetify.breakpoint.xsOnly) binding.column = true
        return binding
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
select {
appearance: menulist;
}
table {
    margin: auto;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pay.vue